// extracted by mini-css-extract-plugin
export default {"modalWrapper":"WrcPW","modal":"YQhw7","modalTitle":"F1AWi","modalTitleText":"mhrQJ","modalText":"OCC_U","btnWrapper":"lwZ23","closeBtn":"_Qib1","deleteBtn":"P6cBu"};